var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNgarko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: "14px",
    height: "14px",
    fill: "#323338",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 16.6",
    style: {
      enableBackground: "new 0 0 14 16.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7429_00000029032457934157017360000010140754146058612150_",
    d: "M2.4,6.6H4v5c0,0.6,0.4,1,1,1h4 c0.6,0,1-0.4,1-1v-5h1.6c0.6,0,1-0.4,1-1c0-0.3-0.1-0.5-0.3-0.7L7.7,0.3c-0.4-0.4-1-0.4-1.4,0L1.7,4.9c-0.4,0.4-0.4,1,0,1.4 C1.9,6.5,2.1,6.6,2.4,6.6z M0,15.6c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H1C0.4,14.6,0,15,0,15.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNgarko);
export default __webpack_public_path__ + "static/media/icon_ngarko.fcfa5ef22fac154fba07aa5c87ef00b5.svg";
export { ForwardRef as ReactComponent };